<template>
  <div>
    <ActionBar
      class="pr-3 align-center"
      show-add
      show-save
      @add="add(suTable.id)"
      @save="saveChanges()"
    />
    <v-data-table
      :headers="headers"
      :items="filterItems"
      class="data-table"
      density="compact"
      disable-sort
      item-key="text"
    >
      <template #loader="{ isActive }">
        <v-progress-linear :active="isActive" color="primary" indeterminate />
      </template>
      <template v-slot:item="{ item }">
        <tr class="soil-type-row" @click="selectedItem = item" @contextmenu="show($event, item)">
          <td style="width: 20%">
            <DataTableField
              :dirtyClass="getDirtyClass(item, 's_effective')"
              :item="item"
              parameter="s_effective"
              @set="setParameter"
              @update="addDirty(item, 's_effective')"
            />
          </td>
          <td>
            <DataTableField
              :dirtyClass="getDirtyClass(item, 'su')"
              :item="item"
              parameter="su"
              @set="setParameter"
              @update="addDirty(item, 'su')"
            />
          </td></tr
      ></template>
    </v-data-table>
    <TableActionMenu
      :addButton="false"
      :selected-item="selectedItem"
      :show-menu="showMenu"
      :x="x"
      :y="y"
      @action="deleteObj(selectedItem.id)"
      @update:show-menu="showMenu = $event"
    />
  </div>
</template>
<script>
import TableActionMenu from '@/components/common/TableActionMenu.vue'
import ShowActionMenuMixin from '@/mixins/ShowActionMenuMixin.vue'
import DirtyFieldsMixIn from '@/mixins/DirtyFieldsMixIn.vue'
import ActionBar from '@/components/common/ActionBar.vue'
import { mapActions, mapState } from 'vuex'
import DataTableField from '@/components/form/DataTableField.vue'

export default {
  name: 'SuTable',
  components: { DataTableField, ActionBar, TableActionMenu },
  mixins: [DirtyFieldsMixIn, ShowActionMenuMixin],
  props: {
    suTable: { required: true }
  },
  data: () => ({
    headers: [{ title: 'S-effective', width: '50%' }, { title: 'Su' }]
  }),
  computed: {
    ...mapState('suTablePoint', {
      items: (state) => state.items
    }),
    filterItems() {
      return this.items.filter((item) => this.suTable.id === item.su_table)
    }
  },
  methods: {
    ...mapActions('suTablePoint', {
      add: 'add',
      create: 'create',
      setParameter: 'setParameter',
      fetchBaseItems: 'fetchItems',
      emptyDirtyItems: 'emptyDirtyItems',
      update: 'update',
      deleteObj: 'deleteItem'
    }),
    async saveChanges() {
      this.writeLoading = true
      try {
        await this.update()
        await this.create()
        this.emptyDirtyItems()
        this.dirtyItems = []
      } catch {
        this.writeLoading = false
      }
      this.writeLoading = false
    }
  }
}
</script>

<style scoped>
.custom-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: unset !important;
}

.data-table:deep(th) {
  text-align: left;
  font-size: 0.75rem;
  font-family: Roboto, sans-serif;
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.6);
}

.data-table:deep(td) {
  padding: 0 !important;
}
.data-table:deep(th) {
  padding: 0 8px !important;
}
</style>
